var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group mt-2" }, [
    _c("label", { staticClass: "form-label", attrs: { for: "cluster_id" } }, [
      _vm._v("\n        Виберiть з випадаючого списку Кластер\n    "),
    ]),
    _vm._v(" "),
    _vm.draw_items.length > 0
      ? _c(
          "div",
          {},
          [
            _c(
              "v-select",
              {
                staticClass: "imc_reasons",
                attrs: {
                  id: "cluster_id",
                  reduce: (item) => item.id,
                  label: "name",
                  options: this.draw_items,
                  filterable: false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return [
                          _c("div", { staticClass: "d-center" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(option.name) +
                                "\n                    "
                            ),
                            _c("div", { staticClass: "small" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.domain) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3767093263
                ),
                model: {
                  value: _vm.active_dep_id,
                  callback: function ($$v) {
                    _vm.active_dep_id = $$v
                  },
                  expression: "active_dep_id",
                },
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v("\n                Оберіть організацію\n            "),
                ]),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }